import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { TranscriptionToggleResponse } from "../videoMeeting.types";

export const toggleVideoMeetingTranscription = async (
  meetingId: number
): Promise<TranscriptionToggleResponse> => {
  return apiRequest(VIDEO_API.TOGGLE_TRANSCRIPTION, "POST", {
    meeting_id: meetingId,
  });
};
